import { GroupedOptionLabelValue, OptionLabelValue } from "../components/rac/select-input";

export function groupedOptions(
	options: { code: string; name: string; grouped?: string }[],
	defaultGroup = "misc",
): GroupedOptionLabelValue[] {
	const groups: Record<string, OptionLabelValue[]> = {};

	options.forEach(o => {
		const group = o.grouped ?? defaultGroup;

		if (!groups[group]) groups[group] = [];
		groups[group].push({ value: o.code, label: o.name });
	});

	return Object.entries(groups).map(([group, options]) => ({
		label: group,
		value: group,
		options,
	}));
}
